module.exports = __webpack_public_path__ + "img/1.a364e6e5.jpg";